import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "../../utils/request";


// Insert Payment
export const fetchCuppon = createAsyncThunk(
  "posts/fetchCuppon",
  async ({ cuppon }, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const res = await request.get(`https://ssl.vipwellness-suite.de/api/coupons/check?code=${cuppon}`);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = { records: [], Loading: false, error: null, isValid: false };

const CupponSlice = createSlice({
  name: 'cuppon',
  initialState,
  reducers: {
    resetCupponStatus: (state) => {
      state.isValid = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCuppon.pending, (state) => {
      state.Loading = true;
      state.error = null;
    });
    builder.addCase(fetchCuppon.fulfilled, (state, action) => {
      state.Loading = false;
      state.isValid = true; // الكوبون صالح
      state.records = action.payload;
    });
    builder.addCase(fetchCuppon.rejected, (state, action) => {
      state.Loading = false;
      state.isValid = false; // الكوبون غير صالح
      state.error = action.payload;
    });
  }
});

export const { resetCupponStatus } = CupponSlice.actions;
export default CupponSlice.reducer;